<template>
	<div class="menu-wrapper">
		<v-navigation-drawer
			app
			floating
			permanent
			class="menu-lateral"
			color="#f9fbff"
			:mini-variant="isCollapsed"
			mini-variant-width="76"
			width="248"
		>
			<div class="brand-block pb-0 pt-0" :class="{ mini: isCollapsed }">
				<div>
					<img src="@/assets/logoSemFundo.png" alt="Logo" width="62" height="50" />
				</div>

				<div v-if="!isCollapsed" class="brand-labels">
					<span class="brand-title">Cargas<span class="brand-subtitle">Zap</span></span>
				</div>
			</div>

			<v-list dense nav class="menu-list">
				<v-list-item
					v-for="item in menuItems"
					:key="item.label"
					class="menu-item mb-0"
					:class="{ active: isActive(item) }"
					link
					@click="handleNavigation(item)"
				>
					<v-list-item-icon>
						<v-badge
							v-if="isVeiculosItem(item)"
							:content="getBadgeContent()"
							:value="documentosVencidosCount > 0"
							color="#ef4444"
							overlap
							class="menu-item__badge"
						>
							<v-icon :color="isActive(item) ? activeColor : iconColor">{{ item.icon }}</v-icon>
						</v-badge>
						<v-badge
							v-else-if="isMotorista(item)"
							:content="getBadgeContentMot()"
							:value="documentosVencidosCountMot > 0"
							color="#ef4444"
							overlap
							class="menu-item__badge"
						>
							<v-icon :color="isActive(item) ? activeColor : iconColor">{{ item.icon }}</v-icon>
						</v-badge>
						<v-icon v-else :color="isActive(item) ? activeColor : iconColor">{{ item.icon }}</v-icon>
					</v-list-item-icon>

					<v-list-item-content v-if="!isCollapsed">
						<v-list-item-title>{{ item.label }}</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</v-list>

			<div class="menu-footer">
				<v-divider class="footer-divider mb-0" />

				<v-list dense nav>
					<v-list-item class="menu-item logout" link @click="logout">
						<v-list-item-icon>
							<v-icon color="#7a8ca6">mdi-logout-variant</v-icon>
						</v-list-item-icon>

						<v-list-item-content v-if="!isCollapsed">
							<v-list-item-title>Sair</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list>
			</div>

			<div class="toggle-container">
				<v-btn icon x-small elevation="3" class="toggle-btn" @click.stop="toggleMenu">
					<v-icon color="#7a8ca6">{{ isCollapsed ? 'mdi-chevron-right' : 'mdi-chevron-left' }}</v-icon>
				</v-btn>
			</div>
		</v-navigation-drawer>

		<v-btn
			class="support-fab"
			color="#16b37c"
			dark
			fab
			elevation="8"
			aria-label="Abrir suporte no WhatsApp"
			title="Suporte no WhatsApp"
			@click="openSupportWhatsapp"
		>
			<v-icon>mdi-whatsapp</v-icon>
		</v-btn>
	</div>
</template>

<script>
import authService from "../services/auth";
import documentacaoServices from "../modules/veiculos/documentacaoServices";
import motoristaServices from "../modules/motoristas/motoristaServices";

const SUPPORT_WHATSAPP_URL = `https://wa.me/55062993410844?text=Olá! Preciso de suporte.`;

export default {
	name: "MenuLateral",

	data() {
		return {
			isCollapsed: false,
			activeColor: "#12b57a",
			iconColor: "#7b8aa2",
			documentosVencidosCount: 0,
			documentosVencidosCountMot: 0,
			menuItems: [
				{ label: "Dashboard", icon: "mdi-view-grid-outline", to: "/inicio" },
				{ label: "Motoristas", icon: "mdi-account-outline", to: "/motoristas" },
				{ label: "Veículos", icon: "mdi-truck-fast-outline", to: "/veiculos" },
				{ label: "Manutenções", icon: "mdi-wrench-clock", to: "/manutencoes-veiculos" },
				{ label: "Multas", icon: "mdi-alert-octagon-outline", to: "/multas-veiculos" },
				{ label: "Viagens", icon: "mdi-map-marker-outline", to: "/viagens" },
				{ label: "CT-e / MDF-e", icon: "mdi-file-document-outline", to: "/ctes-mdfe" },
				{ label: "Empresas", icon: "mdi-domain", to: "/empresas" },
				{ label: "Financeiro", icon: "mdi-calculator", to: "/financeiro" },
				{ label: "Usuários", icon: "mdi-account-multiple-outline", to: "/usuarios" },
				{ label: "Planos", icon: "mdi-credit-card", to: "/planos" },
			],
		};
	},

	methods: {
		isVeiculosItem(item) {
			return item?.label === "Veículos";
		},

		isMotorista(item) {
			return item?.label === "Motoristas";
		},

		getBadgeContent() {
			if (this.documentosVencidosCount > 99) {
				return "99+";
			}

			return this.documentosVencidosCount;
		},

		getBadgeContentMot() {
			if (this.documentosVencidosCountMot > 99) {
				return "99+";
			}

			return this.documentosVencidosCountMot;
		},

		normalizeDate(value) {
			if (!value) {
				return null;
			}

			const normalized = String(value).trim();

			if (/^\d{4}-\d{2}-\d{2}$/.test(normalized)) {
				return normalized;
			}

			const parsed = new Date(normalized);
			if (Number.isNaN(parsed.getTime())) {
				return null;
			}

			return parsed.toISOString().slice(0, 10);
		},

		countExpiredMotoristaDocuments(motorista, today) {
			const fields = ["validade_aso", "validade_toxicologico", "validade_cnh"];

			return fields.reduce((total, field) => {
				const date = this.normalizeDate(motorista?.[field]);
				return date && date < today ? total + 1 : total;
			}, 0);
		},

		async fetchDocumentosVencidos() {
			try {
				const response = await documentacaoServices.verificarDocumentoVencido();
				this.documentosVencidosCount = Array.isArray(response) ? response.length : 0;
			} catch (error) {
				this.documentosVencidosCount = 0;
			}
		},

		async fetchDocumentosVencidosMotoristas() {
			try {
				const response = await motoristaServices.listar();
				const motoristas = Array.isArray(response?.data) ? response.data : [];
				const today = new Date().toISOString().slice(0, 10);

				this.documentosVencidosCountMot = motoristas
					.filter((motorista) => String(motorista?.status || "").toUpperCase() === "ATIVO")
					.reduce((total, motorista) => total + this.countExpiredMotoristaDocuments(motorista, today), 0);
			} catch (error) {
				this.documentosVencidosCountMot = 0;
			}
		},

		refreshBadges() {
			this.fetchDocumentosVencidos();
			this.fetchDocumentosVencidosMotoristas();
		},

		toggleMenu() {
			this.isCollapsed = !this.isCollapsed;
		},

		isActive(item) {
			return Boolean(item.to) && this.$route?.path === item.to;
		},

		openSupportWhatsapp() {
			window.open(SUPPORT_WHATSAPP_URL, "_blank", "noopener,noreferrer");
		},

		handleNavigation(item) {
			if (item.to) {
				if (this.$route?.path !== item.to) {
					this.$router.push(item.to);
				}
				return;
			}

			if (this.$toasted) {
				this.$toasted.show("Disponível em breve");
			}
		},

		logout() {
			authService.logout();
			this.$router.push({ name: "login" });
		},
	},

	mounted() {
		this.refreshBadges();
	},

	watch: {
		$route() {
			this.refreshBadges();
		},
	},
};
</script>

<style scoped>
@import "../assets/inter-font.css";

.menu-wrapper {
	position: relative;
	z-index: 5;
}

.menu-lateral {
	border-right: 1px solid #e6ebf1 !important;
	box-shadow: none !important;
	overflow: visible !important;
	font-family: "Inter", sans-serif;
}

.menu-lateral::v-deep .v-navigation-drawer__content {
	display: flex;
	flex-direction: column;
	height: 100%;
	padding: 18px 12px 12px;
}

.brand-block {
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 6px 6px 14px 6px;
}

.brand-block.mini {
	justify-content: center;
	padding-bottom: 20px;
}

.logo-pill {
	width: 42px;
	height: 42px;
	border-radius: 12px;
	background: linear-gradient(135deg, #1ecb94 0%, #12b57a 100%);
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: 0 10px 22px rgba(18, 181, 122, 0.25);
}

.brand-labels {
	display: flex;
	flex-direction: column;
	line-height: 1.2;
}

.brand-title {
	color: #1f2a44;
	font-weight: 700;
	font-size: 16px;
}

.brand-subtitle {
	color: #16b37c;
	font-weight: 700;
	font-size: 16px;
	letter-spacing: 0.16em;
}

.menu-list {
	padding: 2px 2px;
}

.menu-item {
	border-radius: 12px;
	margin-bottom: 3px;
	min-height: 40px;
	padding: 0 8px;
	border: 1px solid transparent;
	transition: background 0.18s ease, border-color 0.18s ease, box-shadow 0.2s ease;
}

.menu-item .v-list-item__title {
	font-weight: 600;
	font-size: 14px;
	color: #6a7485;
}

.menu-item__badge::v-deep .v-badge__wrapper {
	display: inline-flex;
}

.menu-item__badge::v-deep .v-badge__badge {
	font-size: 10px;
	height: 16px;
	min-width: 16px;
	padding: 0 4px;
	line-height: 16px;
}

.menu-item.active .v-list-item__title {
	color: #12b57a;
}

.menu-item:hover {
	background: #f1f5fb;
}

.menu-item.active {
	background: #e9fbf3;
	border-color: #c8f0de;
	box-shadow: 0 12px 26px rgba(14, 164, 106, 0.12);
}

.menu-lateral.v-navigation-drawer--mini-variant .menu-item .v-list-item__icon {
	padding-top: 20px;
}

.menu-item.logout {
	color: #7a8ca6;
}

.menu-footer {
	margin-top: auto;
	padding-top: 8px;
}

.footer-divider {
	margin: 10px 2px 12px;
}

.toggle-container {
	position: absolute;
	top: 118px;
	right: -14px;
}

.toggle-btn {
	width: 30px;
	height: 30px;
	border-radius: 50% !important;
	background: #f7fafc !important;
	border: 1px solid #dfe6ef;
	box-shadow: 0 10px 18px rgba(0, 0, 0, 0.08) !important;
}

.menu-lateral.v-navigation-drawer--mini-variant .menu-item {
	justify-content: center;
	padding: 0 !important;
	align-items: center;
	max-width: 48px;
	margin-left: auto;
	margin-right: auto;
}

.menu-lateral.v-navigation-drawer--mini-variant .v-list-item__icon {
	margin: 0;
	display: flex;
	justify-content: center;
	width: 100%;
	min-width: 0;
}

.menu-lateral.v-navigation-drawer--mini-variant .v-list-item__icon .v-icon {
	margin: 0 auto;
}

.menu-lateral.v-navigation-drawer--mini-variant .menu-footer {
	padding-left: 6px;
	padding-right: 6px;
}

.support-fab {
	position: fixed;
	right: 5px;
	bottom: 5px;
	z-index: 40;
	width: 52px !important;
	height: 52px !important;
	min-width: 52px !important;
	padding: 0 !important;
	box-shadow: 0 12px 24px rgba(22, 179, 124, 0.22) !important;
	text-transform: none;
	transition: transform 0.18s ease, box-shadow 0.18s ease;
}

.support-fab::before {
	border-radius: 999px;
}

.support-fab:hover {
	transform: translateY(-2px);
	box-shadow: 0 16px 28px rgba(22, 179, 124, 0.26) !important;
}

@media (max-width: 960px) {
	.support-fab {
		right: 16px;
		bottom: 16px;
		width: 48px !important;
		height: 48px !important;
		min-width: 48px !important;
	}
}

</style>
